// biome-ignore-all lint/plugin/no-unlabeled-form-inputs: legacy unlabeled inputs, burn-down tracked in HTUI-392
import { FC } from "react";

import { Row, Select, Text } from "@hightouch/htui";
import { format } from "date-fns";

import { AM_PM_OPTIONS, HOUR_OPTIONS, MINUTE_OPTIONS } from "./constants";
import {
  getMilitaryHoursForMeridiem,
  getTimeParts,
  setTimeParts,
  TimeZone,
} from "./time-parts";

export type Props = {
  value?: Date;
  isDisabled?: boolean;
  onChange: (value: Date) => void;
  onSelectClose?: (elementId: string) => void;
  onSelectOpen?: (elementId: string) => void;
  hideTimeZone?: boolean;
  timeZone?: TimeZone;
};

export const TimeSelect: FC<Readonly<Props>> = ({
  value,
  isDisabled = false,
  onChange,
  onSelectClose,
  onSelectOpen,
  hideTimeZone = false,
  timeZone = "local",
}) => {
  const time = value || new Date();
  const { hours: militaryHours, minutes } = getTimeParts(time, timeZone);

  const isPM = militaryHours >= 12;
  const hours =
    militaryHours === 0
      ? 12
      : militaryHours > 12
        ? militaryHours - 12
        : militaryHours;

  return (
    <Row
      align="center"
      height="32px"
      gap={1}
      sx={{ button: { fontWeight: "medium" } }}
    >
      <Select
        removePortal
        isDisabled={isDisabled}
        options={HOUR_OPTIONS}
        value={hours}
        width="auto"
        onChange={(hours) => {
          if (hours === undefined) {
            return;
          }

          onChange(
            setTimeParts(
              time,
              {
                hours:
                  hours === 12 && !isPM
                    ? 0
                    : isPM && hours < 12
                      ? hours + 12
                      : hours,
              },
              timeZone,
            ),
          );
        }}
        onClose={() => onSelectClose?.("time-select-1")}
        onOpen={() => onSelectOpen?.("time-select-1")}
      />
      <Text fontWeight="medium">:</Text>
      <Select
        removePortal
        isDisabled={isDisabled}
        options={MINUTE_OPTIONS}
        value={minutes}
        width="auto"
        onChange={(minutes) =>
          onChange(setTimeParts(time, { minutes }, timeZone))
        }
        onClose={() => onSelectClose?.("time-select-2")}
        onOpen={() => onSelectOpen?.("time-select-2")}
      />
      <Select
        removePortal
        isDisabled={isDisabled}
        options={AM_PM_OPTIONS}
        value={isPM ? "PM" : "AM"}
        width="auto"
        onChange={(val) => {
          if (val !== "AM" && val !== "PM") return;

          onChange(
            setTimeParts(
              time,
              {
                hours: getMilitaryHoursForMeridiem(militaryHours, val),
              },
              timeZone,
            ),
          );
        }}
        onClose={() => onSelectClose?.("time-select-3")}
        onOpen={() => onSelectOpen?.("time-select-3")}
      />
      {time && !hideTimeZone && (
        <Text>({timeZone === "UTC" ? "UTC" : format(time, "z")})</Text>
      )}
    </Row>
  );
};
